export default __webpack_public_path__ + "media/DevOps.ce82dc00.svg";